var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "page_wrapper" }, [
      _vm._v(" Token has expired. "),
      _vm.page === "confirmregister"
        ? _c("p", [_vm._v("Please contact RAMS support team")])
        : _vm._e(),
      _vm.page === "resetpassword"
        ? _c(
            "p",
            [
              _vm._v(" To resend, please try again "),
              _c("router-link", { attrs: { to: "/forgot" } }, [
                _c("u", [_vm._v("here")]),
              ]),
              _vm._v(". "),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }